import React from "react";
import { useSelector } from "react-redux";
import { DocubirdCache, OneNoteProgId } from "../../../src/taskpane/config/constants";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { automationTargetsOf, getAutomationChoices, IAutomationTarget } from "../../../src/taskpane/services/HooksService";
import { CacheHelper } from "../../../utilities/CacheHelper";
import { IContextualMenuItem } from "@fluentui/react";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { FlowDot20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/FlowDot20Regular";

// The kinds the selected rows are, or null when a OneNote notebook is among them (never offered).
export const selectedRowsAutomationTargets = (rows: any[]): IAutomationTarget[] | null =>
    rows?.some(row => row?.ProgId === OneNoteProgId) ? null : automationTargetsOf(rows ?? []);

export function useMenuItem_Automation(
    selectedItems: any[],
    waitFor: boolean,
    setApprovalFiles: (approvalFiles: any[]) => void,
    setIsApprovalsPanelOpen: (isApprovalsPanelOpen: boolean) => void
) {
    const languageStrings = React.useContext(LanguageContext);
    const tenantEnableApprovalHooks = useSelector((state: RootState) => state.user.tenantEnableApprovalHooks);
    const currentDirectory = useSelector((state: RootState) => (
        state.workingDirectories.workingDirectories.length > 0
            ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1]
            : null
    ));
    // Flips when the hook list in CacheHelper is refreshed, so the menu re-reads it.
    const cacheUpdated = useSelector((state: RootState) => state.cacheUpdate?.toggle);

    const menuItem_Automation = React.useMemo(() => {
        if (selectedItems.length <= 0 || !tenantEnableApprovalHooks || !currentDirectory?.siteDisplayName || (!currentDirectory?.DocumentLibrary && !currentDirectory.sharepointList)) {
            return null;
        }

        const targets = selectedRowsAutomationTargets(selectedItems);
        const allHooks = CacheHelper.get(DocubirdCache.hooks);
        const automationFlowsAvailable = !!targets && getAutomationChoices(allHooks, currentDirectory, targets).length > 0;

        if (automationFlowsAvailable) {
            return {
                key: "approvalHooks",
                disabled: waitFor === true,
                text: languageStrings.Automation,
                // iconProps: { iconName: "DocumentApproval" },
                iconProps: {},
                onRenderIcon: () => <FlowDot20Regular className={menuItemIconStyles} />,
                onClick: () => {
                    setApprovalFiles(selectedItems);
                    setIsApprovalsPanelOpen(true);
                }
            } as IContextualMenuItem;
        }

        return null;

    }, [
        selectedItems,
        waitFor,
        currentDirectory,
        tenantEnableApprovalHooks,
        cacheUpdated,
        languageStrings,
        setApprovalFiles,
        setIsApprovalsPanelOpen
    ]);

    return {
        menuItem_Automation
    };
}